import axios from 'axios'

const HTML_CONTENT_VERSION = 2
const api = axios.create({
	baseURL: '/tutorials/api/v1/tutorials',
	xsrfHeaderName: 'X-CSRF-Token'
})

export default {
	fetchFilters () {
		return api.get('/filters').then(response => response.data)
	},

	fetchTutorial (id) {
		return api.get(`/${id}`).then(response => response.data)
	},

	createTutorial (tutorial) {
		let payload = tutorialPayload(tutorial)
		return api.post('', payload).then(response => response.data)
	},

	updateTutorial (tutorial) {
		let payload = tutorialPayload(tutorial)
		return api.put(`/${tutorial.id}`, payload).then(response => response.data)
	},

	publishTutorial (tutorial, recaptcha) {
		let payload = tutorialPayload(tutorial)
		payload.tutorial.state = 'published'
		payload['g-recaptcha-response'] = recaptcha
		return api.put(`/${tutorial.id}`, payload).then(response => response.data)
	},

	deleteTutorial ({ id }) {
		return api.delete(`/${id}`).then(response => response.data)
	},

	uploadFile (tutorial, file) {
		const { id } = tutorial
		return api.post(`/${id}/upload`, file).then(response => response.data)
	}
}

function tutorialPayload (tutorial) {
	return {
		tutorial: {
			title: tutorial.title,
			description: tutorial.description,
			seo_title: tutorial.seo_title,
			seo_description: tutorial.seo_description,
			steps_attributes: tutorial.steps,
			version_number: HTML_CONTENT_VERSION,

			tag_list: tutorial.tags,
			system_id: tutorial.system_id,
			skill_level: tutorial.skill_level,
			preview_picture_id: tutorial.preview_picture.id,
			content_category_id: tutorial.content_category_id
		}
	}
}
